"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BottomIconButtons = void 0;
var _react = require("react");
var _internal = require("../../hooks/internal");
var _openShadePicker = require("../../utils/internal/openShadePicker");
var _BuyOrNotifyMe = require("./BuyOrNotifyMe");
var _Favorites = _interopRequireDefault(require("./Favorites"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const BottomIconButtons = () => {
  const {
    analyticsData,
    buttons,
    code,
    productListId,
    shades,
    onFavoritesButtonClick
  } = (0, _internal.useProduct)();
  const {
    visible,
    disabled,
    trigger
  } = buttons?.favorites ?? {};

  // istanbul ignore next -- no need to test onClick and preventDefault and stopPropagation
  const onClick = (0, _react.useCallback)(event => {
    event.preventDefault();
    event.stopPropagation();
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.IconWrapper, {
    onClick: onClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_BuyOrNotifyMe.BuyOrNotifyMe, {}), visible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Favorites.default, {
      code: code,
      disabled: disabled,
      shades: shades ?? undefined,
      analyticsData: analyticsData,
      productListId: productListId,
      onFavoritesButtonClick: trigger ? onFavoritesButtonClick ?? (0, _openShadePicker.openShadePicker)(code, analyticsData?.placement) : undefined
    }) : null]
  });
};
exports.BottomIconButtons = BottomIconButtons;
//# sourceMappingURL=BottomIconButtons.js.map